<div
  *ngIf="{ displayProduct: displayProduct$ | async, variantProduct: variantProduct$ | async } as product"
  class="udex-grid udex-mx-auto"
  role="alert">

  <dcp-generic-configurator-error
    imgPath="../../../../assets/images/configurator/add_to_existing_contract_error.png"
    headline="configurator.error.newContract.headline"
    class="udex-mb-20"
  ></dcp-generic-configurator-error>

  <udex-message-strip
    class="col-12 col-md-7 udex-mx-auto udex-mb-20"
    design="Warning"
    status-type="Icon"
    hide-close-button>
    <span class="body--s">
      {{ 'configurator.error.newContract.message1' | cxTranslate }}
      <dcp-open-pdp-link
        [displayProduct]="product.displayProduct"
        [variantProduct]="product.variantProduct"
      ></dcp-open-pdp-link>
      {{ 'common.dot' | cxTranslate }}
      <br>
      {{ 'configurator.error.newContract.message2' | cxTranslate }}
      <dcp-contact-us-link></dcp-contact-us-link>
    </span>
  </udex-message-strip>

  <dcp-cancel-cta-button
    class="udex-mx-auto"
    [displayProduct]="product.displayProduct"
  ></dcp-cancel-cta-button>
</div>
